import { Controller } from '@hotwired/stimulus'
import Cropper from 'cropperjs'
import heic2any from 'heic2any'

/* global FileReader */

export default class extends Controller {
  static targets = ['input', 'image', 'cropX', 'cropY', 'cropWidth', 'cropHeight', 'form', 'cropperContainer', 'instructions']

  connect () {
    this.cropper = null
    console.log('[ProfilePictureCropper] Controller connected')
  }

  disconnect () {
    if (this.cropper) {
      this.cropper.destroy()
      this.cropper = null
    }
  }

  async handleFileSelect (event) {
    console.log('[ProfilePictureCropper] File selected')
    const files = event.target.files
    if (files.length === 0) {
      return
    }

    const onProfileImageFile = (file) => {
      const reader = new FileReader()
      reader.onload = (event) => {
        console.log('[ProfilePictureCropper] Image loaded, initializing cropper')
        this.imageTarget.src = event.target.result
        // Show the cropper container
        this.cropperContainerTarget.classList.remove('hidden')
        console.log('[ProfilePictureCropper] Cropper container shown')
        // Show instructions
        if (this.hasInstructionsTarget) {
          this.instructionsTarget.classList.remove('hidden')
          console.log('[ProfilePictureCropper] Instructions shown')
        }
        if (this.cropper) {
          this.cropper.destroy()
        }
        this.cropper = new Cropper(this.imageTarget, {
          aspectRatio: 1,
          viewMode: 1
        })
        console.log('[ProfilePictureCropper] Cropper initialized', this.cropper)
      }
      reader.readAsDataURL(file)
    }

    // cropperJS doesn't support HEIC, so convert any HEICs to JPEGs.
    // See https://github.com/fengyuanchen/cropperjs/issues/604
    let file = files[0]
    if (['image/heic', 'image/heif'].includes(file.type)) {
      const fileName = file.name
      file = await heic2any({ blob: file, toType: 'image/jpeg' })
      file.name = `${fileName}.jpg`
      onProfileImageFile(file)
    } else {
      onProfileImageFile(file)
    }
  }

  handleSubmit (event) {
    event.preventDefault()
    if (this.cropper) {
      const cropData = this.cropper.getData(true)
      this.cropXTarget.value = cropData.x
      this.cropYTarget.value = cropData.y
      this.cropWidthTarget.value = cropData.width
      this.cropHeightTarget.value = cropData.height
    }
    this.formTarget.submit()
  }
}
